export default __webpack_public_path__ + "static/card-2-6937d006fc82784a08b903cdd718deae.png";